/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Assistant_Suggest_Ask_ExportInputs */



/**
* | output |
* | --- |
* | "How do I export an SRT file?" |
*
* @param {Assistant_Suggest_Ask_ExportInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const assistant_suggest_ask_export = /** @type {((inputs?: Assistant_Suggest_Ask_ExportInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Assistant_Suggest_Ask_ExportInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Comment exporter un fichier SRT ?")
	if (locale === "de") return /** @type {LocalizedString} */ ("Wie exportiere ich eine SRT-Datei?")
	if (locale === "it") return /** @type {LocalizedString} */ ("Come si esporta un file SRT?")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Как экспортировать файл SRT?")
	if (locale === "es") return /** @type {LocalizedString} */ ("¿Cómo exporto un archivo SRT?")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("如何导出SRT文件？")
	if (locale === "ja") return /** @type {LocalizedString} */ ("SRTファイルをエクスポートするにはどうすればよいですか？")
	if (locale === "hi") return /** @type {LocalizedString} */ ("मैं SRT फ़ाइल कैसे निर्यात करूं?")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Como faço para exportar um arquivo SRT?")
	return /** @type {LocalizedString} */ ("How do I export an SRT file?")
});